var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fileConvert"},[_c('input',{attrs:{"id":"inputElement","name":"file","type":"file","accept":"application/pdf"}}),_c('el-button',{attrs:{"size":"small","type":"primary","loading":_vm.uploadLoading},on:{"click":_vm.upload}},[_vm._v("PDF转EXCEL")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }